// Single source for the official G.A.G Demolition logo. Replace only the files, never the design.
// logoSrc: web-optimized copy for the UI. logoMaster: full-resolution original (also at backend/assets/gag-logo.png for PDFs).
export const BRAND = {
  logoSrc: "/brand/gag-logo-768.png",
  logoMaster: "/brand/gag-logo.png",
  name: "G.A.G Demolition",
  colors: { navy: "#000B45", gold: "#FEB601", white: "#FFFFFF" },
};
